module.exports = __webpack_public_path__ + "img/ics_o_save.22e70b44.svg";